export default __webpack_public_path__ + "static/media/icon-orange-close.0054a99f.svg";